<template>
  <div class="IndexPage no-scroll">
    <full-page ref="fullpage" :options="options1">
      <div class="section one">
        <h3>
          <div class="one-text">Ragana</div>
          <div class="one-text1">会员在线预约管理软件</div>
          <div class="more" active-class="active" @click="showBtn">免费试用</div>
        </h3>
        <!-- <p>为你精准推荐健身计划，助你更快达成健身目的</p> -->
        <img src="../assets//image/index1.png" alt="" class="one-img">
      </div>
      <div class="section five">
        <div class="five-inner">
          <h3>健身房管理新体验</h3>
          <div class="p">打造最新健身房管理模式，全面升维场馆训练体验<br>全方位回应健身场馆诉求，自上而下实现⼀体化智能化管理</div>

        </div>
        <img class="fRight" src="../assets/image/index2.png" alt="">
      </div>
      <div class="section two">
        <h3>一个系统连接多款硬件</h3>
        <div class="p">Ragana智能物联设备，目前已对接人脸识别一体机、智能闸机、更衣柜<br>等各种智能设备供客户选择。</div>
        <img src="../assets//image/index3.png" alt="" class="two-img">
      </div>
      <div class="section three">
        <h3>会员服务功能方便快捷</h3>
        <div class="three-inner">
          <div class="three-top">
            <div class="three-top-box">
              <img src="../assets//image/icon1.png" alt="" class="three-top-icon" style="margin-top:4%;">
              <div class="three-top-text" style="margin-top:4%;">
                <div class="title">线上教练展示，私教预约一键搞定</div>
                <div class="text">
                  手机即可查询健身教练信息、证书和荣誉，照片墙展示教练风采；<br> 教练时间安排一目了然，实现线上轻松预约
                </div>
              </div>
            </div>
            <img src="../assets/image/index5.png" alt="" class="three-top-img">
          </div>
          <div class="three-bottom">
            <img src="../assets/image/index4.png" alt="" class="three-bottom-img">
            <div class="three-top-box three-bottom-box">
              <img src="../assets/image/icon2.png" alt="" class="three-bottom-icon">
              <div class="three-top-text">
                <div class="title">手机二维码签到，简单极速入场</div>
                <div class="text">
                  仅需扫描二维码即可实现签到功能
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterVue class="section"></FooterVue>

    </full-page>

    <dialogBox class="section" v-if="showdialogFormVisible" @closeBox="closeBox"
      :showdialogFormVisible="showdialogFormVisible"></dialogBox>
  </div>
</template>

<script setup>
// location.reload()
import { reactive, ref, defineEmits, onMounted } from 'vue';
import FooterVue from '../components/FooterVue.vue';
import dialogBox from '../components/dialogBox.vue';
const changeColor = defineEmits(['changeColor']);

changeColor('changeColor', '')
const showdialogFormVisible = ref(false)
const fullpage = ref()
const options1 = {
  licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
  anchors: ['one', 'two', 'three', 'four', 'five'],
  lockAnchors: true,
  navigation: false,//显示导航
  navigationPosition: 'right',
  verticalCentered: false,
  onLeave: (index, nextIndex) => {
    if (nextIndex.index === 0) {
      changeColor('changeColor', '')
    } else {
      changeColor('changeColor', true)
    }
  },
  afterRender: () => {
    setTimeout(() => {
      fullpage.value.api.moveTo(1, 0);
    }, 200)
  }
}
function showBtn() {
  showdialogFormVisible.value = true
  fullpage.value.api.setAllowScrolling(false)
}
function closeBox() {
  showdialogFormVisible.value = false
  fullpage.value.api.setAllowScrolling(true)
}
function showform() {
  showform
}
</script>

<style lang="scss">
@import '@/assets/css/style.css';

// #fp-nav{
//   position: fixed;
//   right: 10px;
//   top: 40%;
// }
.IndexPage {
  .fp-overflow {
    height: 100%;
  }

  .one-footer {
    position: inherit;
  }

  .section {
    height: 100%;
  }

  .one {
    background: url(../assets/image/banner1.png) no-repeat;
    background-size: 100% auto;
    position: relative;

    .one-img {
      position: absolute;
      bottom: 50px;
      right: 86px;
      height: 70%;
    }

    .phone {
      position: absolute;
      height: 60%;
      top: 24%;
      left: 25%;
    }

    .xiahua {
      position: absolute;
      height: 42px;
      bottom: 10%;
      right: 8%;
    }

    h3 {
      color: #fff;
      font-size: 48px;
      position: absolute;
      left: 8%;
      top: 23%;
      font-weight: 500;
      text-align: center;

      .one-text {
        font-size: 4.48vw;
        margin: 0;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 500;
        color: #FFFFFF;
      }

      .one-text1 {

        font-size: 4.48vw;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 auto 2vw;
      }

      .more {
        width: 11.45vw;
        height: 3.12vw;
        background: #E50A33;
        border-radius: 100px;
        opacity: 1;
        font-size: 1.45vw;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        color: #FFFFFF;
        display: inline-block;
        box-sizing: border-box;
        line-height: 3vw;
        cursor: pointer;
      }

      img {
        position: absolute;
        left: 0;
        top: -60px;
        width: 200px;
      }

      span {
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 93px;
        height: 3px;
        background: #EE144A;
      }
    }

    p {
      color: #fff;
      font-size: 24px;
      position: absolute;
      left: 50%;
      top: 53%;
      opacity: .5;
      width: 384px;
      font-weight: 200;
      line-height: 40px;
    }
  }

  .two {
    background: #FFFFFF;
    ;
    z-index: 99;

    .two-img {
      position: absolute;
      bottom: 0;
      height: 60%;
      left: 0;
      right: 0;
      margin: auto;
    }

    h3 {
      font-size: 3.64vw;
      margin-top: 110px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 500;
      color: #000000;
      text-align: center;
      z-index: 1;
      margin-bottom: 0px;
    }

    h3::after {
      width: 2.5vw;
      height: 2.5vw;
      content: "";
      position: absolute;
      border: 10px solid #E50A33;
      border-radius: 50%;
      margin-top: -1vw;
      margin-left: -1.8vw;
      z-index: -1;
    }

    .p {
      font-size: 1.145vw;
      font-family: AlibabaPuHuiTi-Light;
      font-weight: 400;
      color: #333333;
      line-height: 33px;
      text-align: center;
      margin-top: 50px;
      line-height: 40px;
    }
  }

  .three {
    z-index: 99;
    overflow: hidden;
    position: relative;
    background-color: rgba(243, 243, 243, 1);

    .three-inner {
      width: 80%;
      height: 74%;
      margin: 0 auto;
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;

      .three-top {
        width: 100%;
        height: 50%;
        position: relative;

        .three-top-img {
          position: absolute;
          right: 0;
          top: -10%;
          height: 150%;
        }
      }

      .three-bottom {
        width: 100%;
        height: 50%;
        position: relative;

        .three-bottom-img {
          height: 130%;
          margin-left: 80px;
          display: inline-block;
          vertical-align: middle;
          margin-top: -6%;
        }
      }

      .three-bottom-box {
        display: inline-block;
        vertical-align: middle;
        margin-left: 40px;
      }

      .three-top-box {
        .three-top-icon {
          vertical-align: top;
          display: inline-block;
          width: 68px;
          height: 43px;
          margin-right: 26px;
        }

        .three-bottom-icon {
          vertical-align: top;
          display: inline-block;
          width: 52px;
          height: 52px;
          margin-right: 26px;
        }

        .three-top-text {
          display: inline-block;
          vertical-align: top;

          .title {
            font-family: AlibabaPuHuiTi-Medium;
            font-weight: 500;
            color: #333333;
            font-size: 1.8vw;
            margin-bottom: 15px;
          }

          .text {
            font-size: 1.1vw;
            font-family: AlibabaPuHuiTi-Light;
            font-weight: 400;
            color: #666666;
            line-height: 33px;
          }
        }

      }
    }

    h3 {
      font-size: 3.64vw;
      margin-top: 99px;
      font-family: AlibabaPuHuiTi-Medium;
      font-weight: 500;
      color: #000000;
      text-align: center;
      z-index: 1;
      margin-bottom: 49px;
    }

    h3::after {
      width: 2.5vw;
      height: 2.5vw;
      content: "";
      position: absolute;
      border: 10px solid #E50A33;
      border-radius: 50%;
      margin-top: -1vw;
      margin-left: -1.8vw;
      z-index: -1;
    }
  }

  .five {
    background: url(../assets/image/banner2.png) no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    position: relative;


    .fRight {
      position: absolute;
      right: 0px;
      bottom: 0;
      height: 90%;
    }

    h3::before {
      width: 2.5vw;
      height: 2.5vw;
      content: "";
      position: absolute;
      border: 10px solid #E50A33;
      border-radius: 50%;
      margin-top: -1vw;
      margin-left: -1.8vw;
      z-index: -1;
    }

    .five-inner{
      top: 30%;
      left: 10%;
      z-index: 9;
      position: absolute;
      z-index: 1;
      width: 50%;
    }
    h3 {
      margin-bottom: 0px;
      font-size: 3.64vw;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 500;
      color: #000000; 
    }

    .p {
      font-size: 1.14vw;
      font-family: AlibabaPuHuiTi-Light;
      font-weight: 400;
      color: #333333; 
      margin-top: 50px;
      line-height: 40px; 
    }
  }

  .six {
    background: linear-gradient(181deg, #F8F8F8 0%, #F7F7F7 100%);
    z-index: 99;

    .phone {
      position: absolute;
      height: 70%;
      top: 16%;
      left: 22%;
    }

    h4 {
      font-size: 45px;
      position: absolute;
      left: 48%;
      top: 30%;
      font-weight: 600;

      >div {
        position: relative;
        z-index: 9;
      }

      span {
        position: absolute;
        left: 0;
        bottom: -6px;
        width: 90px;
        height: 20px;
        background: linear-gradient(180deg, rgba(238, 20, 74, 0.1) 0%, rgba(234, 20, 53, 0.43) 54%, rgba(248, 39, 75, 0.79) 100%);
      }
    }

    p {
      color: #fff;
      font-size: 21px;
      position: absolute;
      left: 27%;
      top: 62%;
      opacity: .5;
      width: 384px;
      font-weight: 200;
      line-height: 40px;
    }
  }
}
</style>
